import React from 'react';
import Faq from 'react-faq-component';
import Slider from '../NetflixSlider'
import {  Link } from 'react-router-dom'
import InstructordCard from '../instructor/InstructorCard';
import Objetivo from '../curso/Objetivo';
import {
  Container,
  Divider,
  Dropdown,
  Grid,
  Header,
  Image,
  List,
    Icon, 
    Input,
    Button,
  Menu,
    Transition, 
  Segment,
    Visibility
} from 'semantic-ui-react'


const Insignias = ({insignias}) => {
  let dos=[];
    let datos=[
                  {
                    id: 5,
                    url:"/cursoplay/",
                    image: '/images/capsula.jpeg',
                    imageBg: '/images/capsula.jpeg',
                    title: 'Cápsulas de Control de Calidad'
                      , desc:"Mi descripcnp ipsum dolor sit amet, consectetur adipiscing elit. Pellentesque"+
                          "et euismod ligula. Morbi mattis pretium eros, ut mollis leo tempus"+
                          "eget. Sed in dui ac ipsum feugiat ultricies. Phasellus vestibulum enim"+
                          "quis quam congue, non fringilla orci placerat. Praesent sollicitudin"

                  },
                  {
                    id: 6,
                    url:"/cursoplay/",
                    image: '/images/premium.jpg',
                    imageBg: '/images/premium.jpg',
                    title: 'Cursos Premium Belt'
                      , desc:"Mi descripcnp ipsum dolor sit amet, consectetur adipiscing elit. Pellentesque"+
                          "et euismod ligula. Morbi mattis pretium eros, ut mollis leo tempus"+
                          "eget. Sed in dui ac ipsum feugiat ultricies. Phasellus vestibulum enim"+
                          "quis quam congue, non fringilla orci placerat. Praesent sollicitudin"

                  },
                  {
                    id: 7,
                      url:"/cursoplay/",
                    image: '/images/manejo.jpeg',
                    imageBg: '/images/manejo.jpeg',
                    title: 'Manejo de los sistemas Green Belt y Black Belt'
                      , desc:"Mi descripcnp ipsum dolor sit amet, consectetur adipiscing elit. Pellentesque"+
                          "et euismod ligula. Morbi mattis pretium eros, ut mollis leo tempus"+
                          "eget. Sed in dui ac ipsum feugiat ultricies. Phasellus vestibulum enim"+
                          "quis quam congue, non fringilla orci placerat. Praesent sollicitudin"

                  }
        ];
    return (
    <Segment>
           


    <Segment basic style={{ marginTop: '4em' }}>
    
        <Grid columns={2} divided>
            <Grid.Row>
              <Grid.Column >
                <Segment basic style={{ marginLeft: '2em', marginRight: '2em' }}>
                <Header as='h1'>Insignias Quality Academics</Header>
                <p>Aqui va una descripcion del programa y como obtener las insignias.</p>
      
                <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.</p>
                  

                <Divider hidden="true"/>
                <Divider hidden="true"/>       
                  </Segment>        
              </Grid.Column>
              <Grid.Column>
                  <Image src='/images/insignias.png' fluid   />
              </Grid.Column>
      
            </Grid.Row>
        </Grid>
    </Segment>
            {insignias.map(renglon =>
             
                <Segment basic style={{ marginTop: '4em', marginLeft: '3em' }}>
                    <Header as='h1' dividing>
                        {renglon.titulo}
                    </Header>

                 <Segment placeholder>
                    <Grid columns={2} stackable textAlign='center'>
                      <Divider vertical></Divider>

                      <Grid.Row verticalAlign='middle'>
                        <Grid.Column >
                        <Segment attached='top'>
                                        <Header as='h4'>
                                            Las personas que obtengas esta insignia contaran con las siguientes habilidades
                                        </Header>
                        </Segment>

                        <Objetivo titulo=""  objetivos={renglon.habilidades}/>
                        </Grid.Column>

                        <Grid.Column textAlign="center">
                          <Image src={renglon.imagenInsignia} size="small"   />
                        </Grid.Column>
                      </Grid.Row>
                    </Grid>

                    <Segment basic style={{ marginTop: '4em', marginLeft: '3em' }}>
                        <Header as='h2' dividing>
                            Para obtener la insignia debes completar los siguientes cursos 

                        </Header>


                    <div className="app" style={{backgroundColor: '#000000'}}> 

                     <Slider>
                      {renglon.cursos.map(movie => (
                        <Slider.Item movie={movie}   key={movie.id}>item1</Slider.Item>
                      ))}
                    </Slider>
                    </div>
                    </Segment>        
                </Segment>      
        <Divider hidden/>
          </Segment>
           
        )}
        
    
</Segment>
);
}
 

export default Insignias